import classNames from 'classnames';
import * as React from 'react';
import { Grid } from './Grid';
import { IVector2 } from '@easytwin/runtime';

interface GridMatrixProps {
  className?: string;
  pos: IVector2;
  onPosChanged?: (value: IVector2) => void;
}

export function GridMatrix(props: GridMatrixProps) {
  const { className, pos: position, onPosChanged } = props;

  const onPosChangedWrapper = (pos: IVector2) => {
    onPosChanged?.({ x: pos.x / 2, y: pos.y / 2 });
  };

  const pos = { x: Math.round(position.x * 2), y: Math.round(position.y * 2) };

  return (
    <div className={classNames('w-[64px] h-[64px] relative', className)}>
      <div
        className='absolute top-2 bottom-2 left-2 right-2 pointer-events-none'
        style={{ background: 'rgba(255, 255, 255, 0.02)' }}
      ></div>
      <div className='h-full w-full flex flex-col justify-between items-center'>
        <div className='relative w-full h-3 flex flex-row justify-between items-center'>
          <Grid
            unhighlightClassName='absolute top-[3px] left-[3px]'
            highlightClassName='absolute top-[2px] left-[2px]'
            x={0}
            y={2}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[3px] left-[27px]'
            highlightClassName='absolute top-[2px] left-[26px]'
            x={1}
            y={2}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[3px] left-[51px]'
            highlightClassName='absolute top-[2px] left-[50px]'
            x={2}
            y={2}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
        </div>
        <div className='w-full h-3  flex flex-row justify-between items-center'>
          <Grid
            x={0}
            y={1}
            unhighlightClassName='absolute top-[27px] left-[3px]'
            highlightClassName='absolute top-[26px] left-[2px]'
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[27px] left-[27px]'
            highlightClassName='absolute top-[26px] left-[26px]'
            x={1}
            y={1}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[27px] left-[51px]'
            highlightClassName='absolute top-[26px] left-[50px]'
            x={2}
            y={1}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
        </div>
        <div className='w-full h-3  flex flex-row justify-between items-center'>
          <Grid
            unhighlightClassName='absolute top-[51px] left-[3px]'
            highlightClassName='absolute top-[50px] left-[2px]'
            x={0}
            y={0}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[51px] left-[27px]'
            highlightClassName='absolute top-[50px] left-[26px]'
            x={1}
            y={0}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
          <Grid
            unhighlightClassName='absolute top-[51px] left-[51px]'
            highlightClassName='absolute top-[50px] left-[50px]'
            x={2}
            y={0}
            selectedPos={pos}
            onClick={onPosChangedWrapper}
          />
        </div>
      </div>
    </div>
  );
}
